import React, { useState } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./EditSubscriptions.css";

const EditSubscriptions = ({ userData = {}, onUpdate, onFieldChange }) => {
  const [openIndex, setOpenIndex] = useState(null);

  // Subscription options configuration
  const subscriptionOptions = {
    emailNotifications: {
      mainCategories: [
        { label: "Labnext Newsletter", field: "newsletter" },
        { label: "Labnext Daily Summary", field: "dailySummary" },
        { label: "Labnext Activity Log", field: "activityLog" },
        {
          label: "Cases Created, by the Account",
          field: "casesCreatedByAccount",
        },
        {
          label: "Cases Created, by the Lab",
          field: "casesCreatedByLab",
        },
        { label: "Pickup Requests", field: "pickupRequests" },
        { label: "Balance Payments", field: "balancePayments" },
        { label: "Statements", field: "statements" },
        { label: "Invoices", field: "invoices" },
        { label: "Processes", field: "processes" },
        { label: "Accounts", field: "accounts" },
        {
          label: "Account Changes by Account",
          field: "accountChangedByAccount",
        },
        {
          label: "Account Changes by Lab",
          field: "accountChangedByLab",
        },
        {
          label: "Cases Changed",
          field: "casesChangedByAccount",
        },
      ],

      subCategories: [
        {
          title: "Cases changed, by the Account",
          field: "casesChangedByAccount",
          items: [
            {
              label: "Procedures Changed",
              field: "proceduresChangedByAccount",
            },
            {
              label: "Delivery Date Rescheduled",
              field: "deliveryDateRescheduledByAccount",
            },
            {
              label: "Patient Changed",
              field: "patientChangedByAccount",
            },
            {
              label: "On Hold With Proposal Status Changed",
              field: "onHoldWithProposalStatusChangedByAccount",
            },
            {
              label: "Files Changed",
              field: "filesChangedByAccount",
            },
            {
              label: "Case Canceled",
              field: "caseCanceledByAccount",
            },
            {
              label: "Note Added",
              field: "noteAddedByAccount",
            },
          ],
        },

        {
          title: "Cases changed, by the Lab",
          field: "casesChangedByLab",
          items: [
            {
              label: "Procedures Changed",
              field: "proceduresChangedByLab",
            },
            {
              label: "Delivery Date Rescheduled",
              field: "deliveryDateRescheduledByLab",
            },
            {
              label: "Patient Changed",
              field: "patientChangedByLab",
            },
            {
              label: "Account Changed",
              field: "accountChangedByLab",
            },
            {
              label: "Provider Changed",
              field: "providerChangedByLab",
            },
            {
              label: "On Hold Status Changed",
              field: "onHoldWithProposalStatusChangedByLab",
            },
            {
              label: "Case Arrived/Received By The Lab",
              field: "caseArrivedReceivedByLabByLab",
            },
            {
              label: "Components Changed",
              field: "componentsChangedByLab",
            },
            {
              label: "Files Changed",
              field: "filesChangedByLab",
            },
            {
              label: "Case Canceled",
              field: "caseCanceledByLab",
            },
            {
              label: "Case Closed",
              field: "caseClosedByLab",
            },
            {
              label: "Case Plan/Estimate Changed",
              field: "casePlanEstimateChangedByLab",
            },
            {
              label: "Note Added",
              field: "noteAddedByLab",
            },
          ],
        },
      ],
    },
  };

  const handleCheckboxChange = (fieldType, fieldName, checked) => {
    onFieldChange(fieldType, fieldName, checked);
  };

  const toggleDropdown = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const success = await onUpdate({
      email: userData.email,
      emailNotifications: userData.emailNotifications || {},
    });

    if (success) {
      toast.success("Subscriptions updated successfully!", {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        closeButton: true,
      });
    }
  };

  const email = userData.email || "info@hiradentallab.com";
  const emailNotifications = userData.emailNotifications || {};

  return (
    <div className="subscriptions-wrapper">
      <div className="row">
        <div className="col-md-10">
          <div>
            <h1>Email Subscriptions</h1>

            <form onSubmit={handleSubmit}>
              <div className="Email subscriptions-box">
                <p className="subscriptions-email-text">
                  {email
                    ? `Subscriptions will be sent to: ${email}`
                    : "This user does not have an email address. Subscriptions will be sent to the preferred email address: info@hiradentallab.com"}
                </p>

                {/* Main Categories */}
                {subscriptionOptions.emailNotifications.mainCategories.map(
                  (item, index) => (
                    <div
                      key={index}
                      className={`form-check ${
                        index >= 3 ? "indented-label" : ""
                      } ${
                        index >= 3
                          ? "subscription-main-indented"
                          : "subscription-main-normal"
                      }`}
                    >
                      <input
                        type="checkbox"
                        className="form-check-input"
                        id={`email-${item.field}`}
                        checked={emailNotifications[item.field] || false}
                        onChange={(e) =>
                          handleCheckboxChange(
                            "emailNotifications",
                            item.field,
                            e.target.checked
                          )
                        }
                      />

                      <label
                        className={`form-check-label ${
                          index < 3
                            ? "subscription-main-bold"
                            : "subscription-main-normal-label"
                        }`}
                        htmlFor={`email-${item.field}`}
                      >
                        {item.label}
                      </label>
                    </div>
                  )
                )}

                <br />

                {/* Sub Categories */}
                {subscriptionOptions.emailNotifications.subCategories.map(
                  (category, index) => (
                    <div
                      key={index}
                      className="subscription-category"
                    >
                      <button
                        type="button"
                        className="subscription-category-button"
                        onClick={() => toggleDropdown(index)}
                      >
                        {openIndex === index ? "−" : "+"} {category.title}
                      </button>

                      <br />

                      {openIndex === index && (
                        <div className="sub-items">
                          {category.items.map((subItem, subIndex) => (
                            <div
                              key={subIndex}
                              className="sub-item"
                            >
                              <input
                                type="checkbox"
                                id={`email-${subItem.field}`}
                                checked={
                                  emailNotifications[subItem.field] || false
                                }
                                onChange={(e) =>
                                  handleCheckboxChange(
                                    "emailNotifications",
                                    subItem.field,
                                    e.target.checked
                                  )
                                }
                              />

                              <label
                                htmlFor={`email-${subItem.field}`}
                              >
                                {subItem.label}
                              </label>
                            </div>
                          ))}
                        </div>
                      )}

                      <br />
                    </div>
                  )
                )}
              </div>

              <div className="subscriptions-save">
                <button type="submit">
                  Save Subscriptions
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditSubscriptions;